import React, { useCallback, useEffect, useState } from 'react';
import { Col } from 'react-bootstrap';
import { Dispatch } from "redux";
import { useDispatch } from "react-redux";
import { connect } from "react-redux";
import Menu from '../Menu'
import Header from '../Header';
import useWindowDimensions from '../../helpers/GetCurrentWidth';
import { SetMenuState } from '../../actions/actionCreators';
import { MenuState } from '../../types';

import './styles.css';

function Template(props: any) {

  const [menuShow, setMenuShow] = useState<boolean>(true);
  const [menuClass, setMenuClass] = useState<string>('mobile-menu-closed');
  const logout = () => {
    localStorage.clear();
    window.location.reload();
  };

  useEffect(() => {
    setMenuShow(props.menuState.menuState);

    if (width < 768 && !menuShow) {
      setMenuClass("mobile-menu-open w-75 top-0");
    } else {
      setMenuClass("mobile-menu-closed w-75");
    }
  }, [props.menuState])
  const path = props.path ? props.path : '';
  const { width } = useWindowDimensions();

  const dispatch: Dispatch<any> = useDispatch();

  const handleMenu = useCallback(
    (menuState: boolean) => dispatch(SetMenuState(menuState)),
    [dispatch]
  );

  return (
    <div id='container-template'>
      <Col sm={4} md={4} lg={2} className={width < 768 ? 'd-none' : 'position-fixed'}>
        <Menu />
      </Col>
      <div className={menuClass}>
        <Menu />
      </div>
      <Col id='conteudo-template' sm={width < 768 ? 12 : 8} md={width < 768 ? 12 : 8} lg={width < 768 ? 12 : 10} className={`position-${width < 768 ? 'relative' : 'absolute'} end-0 top-0 `}>
        <Header handleMenu={handleMenu} path={path} />
        <div >
          {props.children}
        </div>
      </Col>
    </div >
  )
}

export const mapStateToProps = (menuState: MenuState) => ({
  menuState
});

export default connect(mapStateToProps)(Template);